export function get500ErrorMessage() {
  const errorMessages = [
    {
      title: "I've made a huge mistake...",
      message:
        "Sorry, we're having some issues on our end. Maybe Jon shouldn't have been watching Arrested Development while he was building this.",
      gif: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExb2I4emsyaXRjc2xsem9ieTVnZXB1d3U1b29jMjZzZG44a2lhZnVxeCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/11BAxHG7paxJcI/giphy.gif",
    },
    {
      title: "Damn, we're in a tight spot...",
      message:
        "Sorry we're having some issues on our end. We'll get some Dapper Dan to smooth things over.",
      gif: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExcDRiZnk4cXRhNnlnN2c3aWk0Nno2eHliaHg0NWp1MTFiYnNzMG5jdiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/1xkbhkrIm2V2LDbUqL/giphy-downsized-large.gif",
    },
    {
      title: "This must be Thursday...",
      message:
        "I never could get the hang of Thursdays. Don't panic! We're just having a little trouble on our end.",
      gif: null,
    },
  ];
  const today = new Date();

  // is it thursday?
  if (today.getDay() === 4) {
    return errorMessages[2];
  }

  // Get a random error message
  const randomIndex = Math.floor(Math.random() * errorMessages.length);
  return errorMessages[randomIndex];
}
